module.exports = __webpack_public_path__ + "assets/img/headerImg-3.927534e5.jpg";